<template>
  <button :class="computedClasses" @click="onClick()">
    {{ text }}
  </button>
</template>

<script>
import { customLogger } from "@/utils";

export default {
  name: "ButtonSubmit",
  props: {
    text: {
      type: String,
      default: "",
    },
    className : {
      type: String,
      default: "validateButtonSubmitBlack",
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedClasses() {
      if (this.type === null)
        return "validateButtonSubmit " + this.className;
      return this.className;
    },
  },
  methods: {
    onClick() {
      this.$emit('submitButton');
      if (this.$store.state.config.storeId == 46) {
        // customLogger("click noo", this.text);
      }
    },
  },
};
</script>

<style scoped>
.validateButtonSubmit {
  font-size: 16px !important;
  text-align: center !important;;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box !important;
  padding: 15px 10px !important;
  margin-top: 10px !important;
  width: 80% !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  cursor: pointer !important;
}

.validateButtonSubmitBlack {
  background-color: #000 !important;
  color: #fff !important;
}

.validateButtonSubmitBlack:hover {
  background-color: #333 !important;
}

.validateButtonSubmitWhite {
  color: #000 !important;
  border: 1px solid #000 !important;
}

.validateButtonSubmitWhite:hover {
  background-color: black !important;
  color: white !important;
}

.validateButtonSubmitDisable {
  background-color: #ccc !important;
  color: #fff !important;
  cursor: not-allowed !important;
}

.validateButtonSubmitDisable:hover {
  background-color: #ccc !important;
  color: #fff !important;
}

.validateButtonMini{
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.validateButton15 {
  width: 15% !important;
}

.validateButton25 {
  width: 25% !important;
}

</style>
